import React, { FC } from 'react';
import ExperienceEditorComponentPlaceholder from '../@shared/experienceEditorComponentPlaceholder';
import EmptyApiDataMessage from '../@shared/emptyApiDataMessage';
import ProductCompatibleLoaderListing from '../productCompatibleLoaderListing';
import { TCHCompatibleLoadersProps } from '../productCompatibleLoaderListing/types/contentHubCompatibleLoaders.types';
import { isEmptyResponse } from '../../utils/checkEmptyResponse';
import { isEditorActive } from '@sitecore-jss/sitecore-jss-react';
import useExperienceEditorPlaceholder from '../../hooks/useExperienceEditorPlaceholder';
import UnreleasedComponent from '../@shared/unreleasedComponent';
import AnalyticsVisibleEvent from '../@shared/analyticsVisibleEvent';
import { modelCompatableAttachmentsVisible } from '../../constants/analytics.constants';
import { descriptionKeyModelCompatibleAttachments, titleKeyModelCompatibleAttachments } from '../../constants/dictionary.constants';

const ProductModelCompatibleAttachmentListing: FC<TCHCompatibleLoadersProps> = (props: TCHCompatibleLoadersProps) => {
  const apiResponse = isEmptyResponse(props);
  const isPlaceholderShown = useExperienceEditorPlaceholder(props);

  // Component is unreleased
  if (props?.fields?.isComponentUnreleased) {
    return <UnreleasedComponent />;
  }

  //  star node opened directly in EE
  if (isPlaceholderShown) {
    return (
      <ExperienceEditorComponentPlaceholder image={props?.fields?.itemData?.thumbnail} componentName={props?.rendering?.componentName} />
    );
  }
  // not opened from star node
  // data missing when navigating via from products node
  if (!apiResponse && isEditorActive()) {
    return <EmptyApiDataMessage componentName={props?.rendering?.componentName} />;
  }

  // No data and not in EE
  if (!apiResponse && !isPlaceholderShown && !isEditorActive()) {
    return null;
  }

  return (
    <AnalyticsVisibleEvent event={modelCompatableAttachmentsVisible}>
      <ProductCompatibleLoaderListing
        {...props}
        hiddenTabs={true}
        id={props?.rendering?.componentName}
        titleKeyCompatibleLoaders={titleKeyModelCompatibleAttachments}
        descriptionKeyCompatibleLoaders={descriptionKeyModelCompatibleAttachments}
        extraClassName={'product-white-spacer'}
      />
    </AnalyticsVisibleEvent>
  );
};

export default ProductModelCompatibleAttachmentListing;
